import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ErrorCodePipe } from '../error-code/error-code.pipe';
import { DealerAssistTableErrorCode } from '../models/communication/baccarat-enums.model';

@Component({
    selector: 'app-error-panel',
    standalone: true,
    imports: [CommonModule, ErrorCodePipe],
    templateUrl: './error-panel.component.html',
    styleUrl: './error-panel.component.scss'
})
export class ErrorPanelComponent {
    @Input()
    errorCode?: DealerAssistTableErrorCode;
}
